module.exports = global["_REQJS_"] = require("-!/walletexpnodeweb-ci-6534/workspace/consumerweb-release/node_modules/exports-loader/index.js?requirejs,define!/walletexpnodeweb-ci-6534/workspace/consumerweb-release/public/js/lib/require-2.1.6.js");


//////////////////
// WEBPACK FOOTER
// ./lib/require-2.1.6.js
// module id = 4
// module chunks = 0